Go to **[Create IAM role](https://console.aws.amazon.com/iam/home?#/roles$new?step=type)**,
pick the following for the trusted entity:

- Trusted entity type: AWS service
- Use case: EC2

For the permission, choose the policy you just created above.
We recommend also naming the role "pganalyze" or similar.
